function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useState, useRef, useEffect } from 'react';
import ReactTooltip from 'Shared/Tooltip';
import useAsset from '../../hook/useAsset';
import { Accordion, AccordionItem, Box } from '@tapresearch/ui/components';
import * as S from './BarChart.styled';
export default function(param) {
    var isCrossTab = param.isCrossTab, data = param.data, id = param.id, mode = param.mode;
    var asset = useAsset();
    var _useState = _sliced_to_array(useState(), 2), graphData = _useState[0], setGraphData = _useState[1];
    var toolTipId = useRef("toolTipId-".concat(id));
    var _useState1 = _sliced_to_array(useState({
        array: [],
        map: {}
    }), 2), accordionState = _useState1[0], setAccordionState = _useState1[1];
    var handleSetAccordionState = function(expandedIndex) {
        setAccordionState({
            array: expandedIndex,
            map: expandedIndex.reduce(function(prev, curr) {
                prev[curr] = true;
                return prev;
            }, {})
        });
    };
    useEffect(function() {
        if (isCrossTab) {
            setGraphData({
                legends: data.secondaryAnswers.reduce(function(acc, _, i) {
                    return _object_spread_props(_object_spread({}, acc), _define_property({}, i, true));
                }, {}),
                datasets: data.datasets,
                secondaryAnswers: data.secondaryAnswers,
                total: data.total
            });
        } else {
            setGraphData(_object_spread_props(_object_spread({}, data), {
                legends: data.datasets.reduce(function(acc, _, i) {
                    return _object_spread_props(_object_spread({}, acc), _define_property({}, i, true));
                }, {})
            }));
        }
    }, [
        data
    ]);
    useEffect(function() {
        ReactTooltip.rebuild();
    }, [
        graphData
    ]);
    var onChangeLegendsFilter = function(field) {
        var newLegends = _object_spread_props(_object_spread({}, graphData.legends), _define_property({}, field, !graphData.legends[field]));
        setGraphData(_object_spread_props(_object_spread({}, graphData), {
            legends: newLegends
        }));
    };
    if (!graphData || !graphData.legends) {
        return null;
    }
    var renderLegend = function() {
        var legendMap = isCrossTab ? graphData.secondaryAnswers || [] : graphData.datasets || [];
        return /*#__PURE__*/ React.createElement(S.LegendContainer, null, legendMap.map(function(_, idx) {
            return /*#__PURE__*/ React.createElement(S.LegendItem, {
                key: idx
            }, /*#__PURE__*/ React.createElement(S.Legend, {
                onClick: function() {
                    return onChangeLegendsFilter(idx);
                },
                background: S.getBarLabelColor(idx)
            }, /*#__PURE__*/ React.createElement(S.LegendIcon, {
                src: graphData.legends[idx] ? asset.check_square_icon : asset.square_regular_icon
            }), "#".concat(idx + 1)));
        }));
    };
    var getTooltipContent = function(dataTip) {
        if (!dataTip) return;
        var value;
        if (isCrossTab) {
            var _dataTip_split = _sliced_to_array(dataTip.split('-'), 2), primaryLookup = _dataTip_split[0], secondaryLookup = _dataTip_split[1];
            if (graphData.datasets[primaryLookup] && graphData.datasets[primaryLookup].values && graphData.datasets[primaryLookup].values[secondaryLookup] && graphData.secondaryAnswers) {
                value = graphData.datasets[primaryLookup].values[secondaryLookup];
            }
        } else {
            value = graphData.datasets[dataTip];
        }
        return value && value.ranks && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("p", null, value.label), /*#__PURE__*/ React.createElement("div", null, "Average rank:", ' ', parseFloat(value.weighted_sum / value.total || 0).toFixed(2)), value.ranks.map(function(count, idx) {
            return /*#__PURE__*/ React.createElement("div", {
                key: idx
            }, count, " (", (parseFloat(count / value.total) * 100).toFixed(2), "%) respondents ranked this #", idx + 1);
        }));
    };
    return /*#__PURE__*/ React.createElement("div", null, isCrossTab ? /*#__PURE__*/ React.createElement(Box, Styles.AccordionContainer, /*#__PURE__*/ React.createElement(Accordion, {
        onChange: function(i) {
            return handleSetAccordionState(i);
        },
        index: accordionState.array
    }, graphData.datasets.map(function(dataset, idx) {
        return /*#__PURE__*/ React.createElement(ChartRow, {
            isExpanded: accordionState.map[idx],
            key: idx,
            rowIndex: idx,
            dataset: dataset,
            legends: graphData.legends,
            isCrossTab: true,
            toolTipId: toolTipId.current,
            mode: mode,
            total: graphData.total
        });
    }))) : /*#__PURE__*/ React.createElement(React.Fragment, null, graphData.datasets.map(function(dataset, idx) {
        return /*#__PURE__*/ React.createElement(ChartRow, {
            total: graphData.total,
            dataset: dataset,
            key: idx,
            rowIndex: idx,
            toolTipId: toolTipId.current,
            legends: graphData.legends,
            mode: mode
        });
    })), renderLegend(), /*#__PURE__*/ React.createElement(S.Tooltip, {
        id: toolTipId.current,
        place: "top",
        type: "dark",
        getContent: getTooltipContent
    }));
};
var ChartRow = function(param) {
    var dataset = param.dataset, isCrossTab = param.isCrossTab, rowIndex = param.rowIndex, legends = param.legends, toolTipId = param.toolTipId, mode = param.mode, isExpanded = param.isExpanded;
    var labelRef = useRef();
    var _useState = _sliced_to_array(useState(0), 2), height = _useState[0], setHeight = _useState[1];
    useEffect(function() {
        if (labelRef.current) {
            setHeight(labelRef.current.clientHeight);
        }
    }, []);
    if (isCrossTab) {
        var rowTotal = dataset.total / Object.keys(legends).length;
        var hasData = rowTotal > 0 && dataset.values;
        return /*#__PURE__*/ React.createElement(AccordionItem, _object_spread_props(_object_spread({}, Styles.AccordionItem), {
            isDisabled: !hasData,
            itemTitle: /*#__PURE__*/ React.createElement(S.ChartRowTitle, null, /*#__PURE__*/ React.createElement(S.ChartRowItem, null, dataset.label, " (", rowTotal, ")"), hasData && /*#__PURE__*/ React.createElement(S.ChartRowItem, null, "Top Answer: ", dataset.values[0].label))
        }), isExpanded && dataset.values.map(function(value, idx) {
            var percentage = parseFloat((value.total / dataset.total || 0) * 100).toFixed(2);
            if (!percentage || percentage <= 0) {
                return null;
            }
            return /*#__PURE__*/ React.createElement(RankingRow, {
                key: idx,
                dataset: value,
                isCrossTab: true,
                rowIndex: rowIndex,
                labelRef: labelRef,
                mode: mode,
                toolTipId: toolTipId,
                secondaryIdx: idx,
                legends: legends
            });
        }));
    }
    return /*#__PURE__*/ React.createElement(RankingRow, {
        dataset: dataset,
        height: height,
        rowIndex: rowIndex,
        labelRef: labelRef,
        secondaryIdx: rowIndex,
        toolTipId: toolTipId,
        legends: legends,
        mode: mode
    });
};
var RankingRow = function(param) {
    var dataset = param.dataset, rowIndex = param.rowIndex, secondaryIdx = param.secondaryIdx, mode = param.mode, toolTipId = param.toolTipId, isCrossTab = param.isCrossTab, legends = param.legends;
    var barPercentage = 100;
    return /*#__PURE__*/ React.createElement(S.Row, null, /*#__PURE__*/ React.createElement("span", {
        style: {
            marginRight: '15px',
            fontWeight: '700'
        }
    }, "~".concat((dataset.weighted_sum / dataset.total).toFixed(2))), /*#__PURE__*/ React.createElement(S.RowLabel, null, dataset.label), /*#__PURE__*/ React.createElement(S.RowBar, null, /*#__PURE__*/ React.createElement(S.Bar, null, /*#__PURE__*/ React.createElement(S.CrossTabRow, {
        percentage: barPercentage,
        "data-for": toolTipId,
        "data-tip": isCrossTab ? "".concat(rowIndex, "-").concat(secondaryIdx) : secondaryIdx
    }, dataset.ranks && dataset.ranks.map(function(rankCount, idx) {
        var percentage = parseFloat((rankCount / dataset.total || 0) * 100).toFixed(2);
        if (!percentage || percentage <= 0 || !legends[idx]) {
            return null;
        }
        var bg = S.getBarLabelColor(idx);
        return /*#__PURE__*/ React.createElement(S.BarItem, {
            key: idx,
            background: bg,
            percentage: percentage
        }, /*#__PURE__*/ React.createElement(S.BarItemLabel, {
            color: bg,
            style: {
                visibility: 'initial'
            }
        }, mode === 'percentage' ? "".concat(percentage, "%") : rankCount));
    })))));
};
var Styles = {
    AccordionContainer: {
        borderRadius: 8,
        p: 3,
        border: '1px solid',
        borderColor: 'gray.200'
    },
    AccordionItem: {
        _buttonStyle: {
            fontSize: 'md',
            minH: '32px',
            borderTop: '1px solid',
            borderColor: 'gray.200',
            p: '12px 8px'
        },
        _buttonStyleExpanded: {
            mb: '8px'
        },
        _panelStyle: {
            p: '20px 8px'
        }
    }
};
